import { Images } from "constants";
import { UserContext } from "context";
import { adminLogin, login } from "features";
import React, { useContext, useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import "../../assets/css/onboard.css";
import { allCities, allStates, getMasterData } from "_services";
import StorageService from "utils/StorageServices/StorageServices";
import { CommonInput } from "components";
import { errorSchema, utils } from "helper";
import { StorageServices } from "utils";
import toast from "react-hot-toast";

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading, error, data } = useSelector((state) => state.auth);
  const { setGenrateOtp, genrateOtp } = useContext(UserContext);
  const { setToken } = useContext(UserContext);
  const getUserData = JSON.parse(localStorage.getItem('userData'));
  const [form, setForm] = useState({
    username: "",
    password: "",
  });

  const [formError, setFormError] = useState("");
  

  // useEffect(() => {
  //   allCities();
  //   getAllMasterData();
  //   allStates();
  // }, []);


  
  const handleSubmit = async (e) => {
    e.preventDefault();
  
    const validationResult = await utils.checkFormError(
      form,
      errorSchema.adminLogin
    );
  
    if (validationResult === true) {
      try {
        const res = await dispatch(
          adminLogin({
            phoneNumber: form?.username,
            password: form?.password,
            appVersion: "1.0.0",
            countryCode: "+91",
            deviceToken: "22344",
            ipAddress: "sdjh688",
            os: "ios",
            osVersion: "18.3",
            language: "en",
            latitude: "",
            longitude: "",
            city: "",
            state: "",
            country: ""
          })
        );
  
        const statusCode = res?.meta?.requestStatus === 'fulfilled' ? 200 : null;
        const responseData = res?.payload;
  
        if (statusCode === 200 && responseData?.status === 1) {
          StorageServices.setLocalItem('AdminData', JSON.stringify(res?.meta?.arg));
          navigate("/verify");
          setGenrateOtp(true);
          toast.success(responseData.message || "OTP sent successfully.");
        } else {
          toast.error(responseData?.message || "Login failed.");
        }
  
      } catch (error) {
        console.error(error);
        toast.error("An error occurred. Please try again.");
      }
    } else {
      setFormError(validationResult);
    }
  };
  
  



  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   const validationResult = await utils.checkFormError(
  //     form,
  //     errorSchema.adminLogin
  //   );

  //   if(validationResult ==true){
  //     try {
  //       const res = await dispatch(
  //         adminLogin({ phoneNumber: form?.username, password: form?.password, appVersion:"1.0.0",
  //           countryCode:"+91",
  //           deviceToken:"22344",
  //           ipAddress:"sdjh688",
  //           os:"ios",
  //           osVersion:"18.3",
  //           language: "en",
  //           latitude: "",
  //           longitude: "",
  //           city: "",
  //           state: "",
  //           country: ""
  //          })
  //       );
  //       if (!!res) {
  //         StorageServices.setToken(res?.payload?.data?.user?.token);
  //         StorageServices.setLocalItem('userData', JSON.stringify(res?.payload?.data?.user));
  //         setToken(res?.payload?.data?.user?.token);
  //         navigate("/verify");
  //       }
  //       else if(res.payload){
  //         toast.error(res.payload?.message);
  //       }
  //     } catch (error) {
  //       throw error;
  //     }
  //   }else{
  //     setFormError(validationResult)
  //   }
    
  // };



  // const getAllMasterData = async () => {
  //   const postData = {};
  //   try {
  //     let response = await getMasterData(postData);
  //     if (response?.responseCode === 200) {
  //       StorageService.setLocalItem(
  //         "master_data",
  //         JSON.stringify(response.data)
  //       );
  //     } else {
  //       throw response?.responseMessage;
  //     }
  //   } catch (error) {
  //     console.error("Error fetching master data:", error);
  //     throw error;
  //   } finally {
  //   }
  // };

  const handleOnChange = async (name, value) => {
    setForm((prevForm) => {
      const updatedForm = {
        ...prevForm,
        [name]: value,
      };

      if (formError) {
        utils
          .checkFormError(
            {
              ...updatedForm,
            },
            errorSchema.adminLogin
          )
          .then((validationResult) => {
            if (validationResult === true) {
              setFormError("");
            } else {
              setFormError(validationResult);
            }
          });
      }

      return updatedForm;
    });
  };

  return (
    <div className="_midOb_bx">
      <div className="_innrMid_bx">
        <img className="_logoOn_board" src={Images.LOGO} alt="" />

        <div className="_midOd_head">
          <h3>Welcome to MySifarish Admin </h3>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="_subFrm_fx">
            <div className=" mt-4">
              <CommonInput
                // placeholder="Phone"
                label="Phone"
                labelRedStar={true}
                type="tel"
                maxLength={10}
                name="username"
                onChange={({ target: { name, value } }) => {
                  handleOnChange(name, value);
                }}
                value={form?.phoneNumber}
                focus={formError?.phoneNumber}
                error={formError?.phoneNumber}
              />
            </div>
            <div className="">
              <CommonInput
                type="password"
                label="Password"
                labelRedStar={true}
                name="password"
                onChange={({ target: { name, value } }) => {
                  handleOnChange(name, value);
                }}
                value={form?.password}
                focus={formError?.password}
                error={formError?.password}
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              className="anime-btn _submitOn_board"
            >
              {loading ? "Verifing.." : "Login"}{" "}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;
